import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom"
import * as XLSX from 'xlsx';
import QueryBuilder from 'react-querybuilder';
import 'react-querybuilder/dist/query-builder.css';
import { useFormik } from "formik"
import * as Yup from "yup"
import "./siteUrl.css"
import {
  Card,
  CardBody,
  CardDeck,
  CardTitle,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
} from "reactstrap"

import Dropzone from "react-dropzone"

import { connect } from "react-redux"

import { setBreadcrumbItems } from "../../store/actions"
import { scrollToView, showToaster } from "components/Common/common";
import { useSelector } from "react-redux";
import { PAGECODE, PAGEPATHS, SIDEBARDATA } from "components/Common/Constant";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames, METABASE, VIEW_TYPE_OPTIONS } from "components/Common/ApiManagement/apiServices";

const ReferranceTableCreate = props => {
  document.title = "Add Site URL's"
  const user = useSelector((state) => state?.users?.users);
  const [bulkUrls, setBulkUrls] = useState({})
  const breadcrumbItems = [
    { title: "GovCompliance", link: "#" },
    { title: "AddSiteURL", link: "#" },
  ]
  const fields = [
    { name: 'fieldName', label: 'Field Name', type: 'text' },
    { name: 'scanName', label: 'Scan Name', type: 'text' },
    { name: 'category', label: 'Category', type: 'text' },
    { name: 'scanTitle', label: 'Scan Title', type: 'text' },
    { name: 'scanGroup', label: 'Scan Group', type: 'text' },
    { name: 'scanSubcat', label: 'Scan Subcategory', type: 'text' },
    { name: 'auditDesc', label: 'Audit Description', type: 'text' },
    {
      name: 'complianceMappings.area',
      label: 'Compliance Area',
      type: 'text'
    },
    {
      name: 'complianceMappings.isDirect',
      label: 'Is Direct Compliance',
      type: 'boolean'
    }
  ];
  const navigate = useNavigate();
  const [uploadingLoad, setUploadLoad] = useState(false)
  const [viewUploadingLoad, setViewUploadLoad] = useState(true)
  const getScanList = async () => {
    try {
      const response = await axiosInstance.post(ApiNames.REFERRENCE_TABLE_LIST);
      console.log(response, "response");



    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getScanList()
  }, [user]);
  const valSchema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
    ["Url Address"]: Yup.string()
      .required("Url Address is required"),
    ["Parent Website"]: Yup.string()
      .required("Parent Website is required"),
    Environment: Yup.string()
      .oneOf(["dev", "qa", "uat", "prod"], "Environment must be either prod, dev, qa or uat")
      .required("Environment is required"),
  });

  const urlSchema = Yup.array().of(valSchema);

  const handleDoc = async (file) => {
    if (file) {
      const reader = new FileReader()

      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        const json = XLSX.utils.sheet_to_json(worksheet)
        try {
          await urlSchema.validate(json, { abortEarly: false })
        } catch (err) {
          console.log(err.errors);
          // showToaster(0, err.errors[0])
          setBulkUrls({})
          return
        }
        let obj = {}
        for (let i = 0; i < json.length; i++) {
          const {
            Environment,
            Name,
            ["Url Address"]: urlAddress,
            ["Parent Website"]: parentWebsite
          } = json[i]
          obj[Environment]
            ? obj[Environment].push({ Name, urlAddress, parentWebsite })
            : obj[Environment] = [{ Name, urlAddress, parentWebsite }]
        }
        setBulkUrls(obj)
        scrollToView('url-environment')
      }

      reader.readAsArrayBuffer(file)
    }
  }




  const [selectedView, setSelectedView] = useState(0);
  const [selectedFiles, setselectedFiles] = useState([])
  const [state, setState] = useState({
    activeTab: "1",

  })
  useEffect(() => {
    props.setBreadcrumbItems("Referrance Table Create", [])
  })

  useEffect(() => {
    const fetchViewType = async () => {
      try {
        const res = await axiosInstance.post(ApiNames.VIEW_METHOD_GET);
        console.log("dsfgdsf", res.data)
        setSelectedView(res.data.data);
      } catch (err) {
        console.error('Error fetching view config', err);
      } finally {
        setViewUploadLoad(false)
      }
    };

    fetchViewType();
  }, []);


  const handleAcceptedFiles = files => {
    handleDoc(files[0])
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    )
    setselectedFiles(files)
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }



  const handleViewUpload = async (e) => {
    const newValue = parseInt(e.target.value);
    setSelectedView(newValue);
    setViewUploadLoad(true)

    try {
      const response = await axiosInstance.post(ApiNames.VIEW_METHOD_UPLOAD, { viewType: newValue });

      if (response.data.status) {
        console.log('Upload successful:', response.data);
        showToaster(1, "View type saved successfully")
        // Optional: Show a toast or update state
      } else {
        console.error('Upload failed:', response.statusText);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
    } finally {
      setViewUploadLoad(false)
    }
  };






  const handleUpload = async (files) => {

    console.log(files, "filesfiles")
    if (!files || files.length === 0) {
      showToaster(0, 'Please select a file!');
      return;
    }
    setUploadLoad(true)
    const formData = new FormData();
    formData.append('file', files[0]); // Assuming single file upload

    try {
      const response = await axiosInstance.post(ApiNames.REFERRENCE_TABLE_CREATE, formData);

      if (response.data.status) {
        console.log('Upload successful:', response.data);
        showToaster(1, response.data.message)
        // Optional: Show a toast or update state
      } else {
        console.error('Upload failed:', response.statusText);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
    } finally {
      setUploadLoad(false)
    }
  };

  const handleOpenMetabase = () => {
    window.open(`${METABASE.adminRoute}`, '_blank');
  };

  return (
    <React.Fragment>
      <Row className="justify-center">
        <Col lg={12}>
          <Card>
            <CardBody>
              <CardTitle className="h4 flex flex-col md:flex-row items-center"><h4>Add Excel Sheet</h4>

                <button
                  type="button"
                  className="waves-effect d-flex align-items-center waves-light btn btn-primary md:ms-auto"
                  style={{ fontSize: "0.9rem", width: 'fit-content', marginBottom: '1em' }}
                  onClick={() => navigate("/comprehensiveCompliance")}
                >
                  <i className="mdi mdi-plus fw-bold font-size-17 pe-1"></i>{" "}
                  Metabase Edit
                </button>
              </CardTitle>


              <TabContent
                activeTab={state.activeTab}
                className="p-3 text-muted"
              >
                <TabPane tabId="1">
                  <Row>
                    <Col className="col-md-8 mx-auto">
                      <Card>
                        <CardBody>
                          <Form>


                            <FormGroup className="w-50 mx-auto d-flex flex-column gap-2">
                              {viewUploadingLoad ? <h4>Loading...</h4> :
                                <select className="form-control form-control-lg" value={selectedView} onChange={handleViewUpload}>
                                  {VIEW_TYPE_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              }
                            </FormGroup>






                            <Dropzone
                              onDrop={acceptedFiles => {
                                handleAcceptedFiles(acceptedFiles)
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable px-3 md:px-7">
                                  <div
                                    className="dz-message needsclick"
                                    {...getRootProps()}
                                  >
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                      <i className="mdi mdi-cloud-upload-outline text-muted display-4"></i>
                                    </div>
                                    <h4 className="opacity-50 text-[14px] md:text-[20px]">
                                      Drop Excel here or click to upload.
                                    </h4>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            <div
                              className="dropzone-previews mt-3"
                              id="file-previews"
                            >
                              {selectedFiles.map((f, i) => {
                                return (
                                  <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                  >
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                          />
                                        </Col>
                                        <Col>
                                          <Link
                                            to="#"
                                            className="text-muted font-weight-bold"
                                          >
                                            {f.name}
                                          </Link>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                )
                              })}
                            </div>
                          </Form>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>


                  <Row>
                    <Col xl={12}>
                      <div className="d-flex justify-content-center text-white">


                        {uploadingLoad ?
                          <Button
                            style={{ paddingBlock: '0.5rem', paddingInline: '1rem', width: 'fit-content' }}
                            type="submit"
                            className="btn-primary fs-5"
                            disabled
                          >
                            Loading...
                          </Button> :
                          <Button
                            style={{ paddingBlock: '0.5rem', paddingInline: '1rem', width: 'fit-content' }}
                            type="submit"
                            className="btn-primary fs-5"
                            onClick={() => handleUpload(selectedFiles)}
                          >
                            <i className="mdi mdi-content-save"></i> {"Upload"}
                          </Button>
                        }




                      </div>
                    </Col>
                  </Row>
                </TabPane>

              </TabContent>

            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(ReferranceTableCreate)
